import { render, staticRenderFns } from "./CruResourceFooter.vue?vue&type=template&id=1b4ccd00&"
import script from "./CruResourceFooter.vue?vue&type=script&lang=js&"
export * from "./CruResourceFooter.vue?vue&type=script&lang=js&"
import style0 from "./CruResourceFooter.vue?vue&type=style&index=0&id=1b4ccd00&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports